import { FormEvent } from "react"

import { InputNew } from "components/form/InputNew"
import { InputPhone } from "components/form/InputPhone"

interface ContractorUserFormFieldsProps {
  fullName: string
  email: string
  phone: string
  isEdit?: boolean
  onInputChange: (event: FormEvent<HTMLInputElement>) => void
  onPhoneChange: (value: string) => void
  error: {
    field: string
    message: string
  }
}

const ContractorUserFormFields = ({
  fullName,
  email,
  phone,
  isEdit,
  onInputChange,
  onPhoneChange,
  error,
}: ContractorUserFormFieldsProps) => {
  return (
    <>
      <InputNew
        label="Full Name"
        placeholder="Enter full name"
        name="fullName"
        value={fullName}
        onChange={onInputChange}
        errorMessage={error.field === "fullName" ? error.message : ""}
      />
      <InputNew
        label="Email"
        placeholder="Enter Email"
        name="email"
        value={email}
        onChange={onInputChange}
        disabled={isEdit}
        errorMessage={error.field === "email" ? error.message : ""}
      />
      <InputPhone
        label="Phone (optional)"
        placeholder="Enter phone number"
        name="phone"
        value={phone || ""}
        onChange={value => onPhoneChange(value)}
        errorMessage={error.field === "phone" ? error.message : ""}
      />
    </>
  )
}

export default ContractorUserFormFields
